<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      floating
    >
      <v-list-item>
        <v-img
          src="../../public/VM Logo Gray-Blue-White RGB.jpg"
          alt="Valet Moving"
          max-height="120"
          max-width="170"
        />
      </v-list-item>
      <v-divider />
      <v-list
        nav
      >
        <template v-for="(item, idx) in items">
          <v-list-item
            :key="idx"
            link
            :to="item.link"
            exact
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :to="item.link">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-divider />
      <v-btn
        text
        color="blue darken-1"
        ripple
        @click="$router.push('/changePassword')"
      >
        Change Password
      </v-btn>
      <v-divider />
      <v-btn
        text
        color="blue darken-1"
        ripple
        @click="logout"
      >
        Logout
      </v-btn>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.mdAndDown"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <omni-search-component />
    </v-app-bar>
    <v-main>
      <v-container
        fluid
      >
        <router-view :key="$route.fullPath" />
      </v-container>
    </v-main>
    <v-footer
      :fixed="fixed"
      app
    >
      <span>2020 - Made with 💙 by Matt</span>
    </v-footer>
  </v-app>
</template>

<script>
import OmniSearchComponent from '../components/OmniSearchComponent.vue';

export default {
  components: {
    OmniSearchComponent,
  },
  data: () => ({
    drawer: null,
    fixed: true,
    items: [
      {
        icon: 'mdi-folder-plus-outline',
        text: 'Receiving',
        link: '/inventory/new',
      },
      {
        icon: 'mdi-magnify',
        text: 'Inventory',
        link: '/inventory',
      },
      {
        icon: 'mdi-database-clock',
        text: 'Pending Inventory',
        link: '/inventory/pending',
      },
      {
        icon: 'mdi-newspaper-variant-outline',
        text: 'Clients',
        link: '/clients',
      },
      {
        icon: 'mdi-table-chair',
        text: 'Manufacturers',
        link: '/manufacturers',
      },
      {
        icon: 'mdi-cash-usd-outline',
        text: 'Charge Reports',
        link: '/inventory/charges',
      },
      {
        icon: 'mdi-file-chart-outline',
        text: 'Master Report',
        link: '/reports/master',
      },
      {
        icon: 'mdi-contacts-outline',
        text: 'Settings',
        link: '/settings',
      },
      {
        icon: 'mdi-chart-bar',
        text: 'Metrics',
        link: '/metrics',
      },
    ],
  }),
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'));
    },
  },
};
</script>
